import { Option } from '@/types/components/common';

export type CurrencyCode = 'USD' | 'KYD';

export const CURRENCY_OPTIONS: Option[] = [
  { value: 'USD', text: 'USD' },
  { value: 'KYD', text: 'KYD' },
];
